module.exports = __webpack_public_path__ + "static/media/eye.a6ce15c0.svg";